import { DomainScopes } from "../../constants/DomainConstants";
import { orderByPropertyName } from "../../util/orderBy";

const tabTypes = [
	{
		typeId: 121450000,
		title: "Organisator",
		tabNumber: 0
	},
	{
		typeId: 121450001,
		title: "Tocht",
		tabNumber: 1
	},
	{
		typeId: 121450002,
		title: "Lus",
		tabNumber: 2
	},
	{
		typeId: 121450003,
		title: "Publicatie",
		tabNumber: 3
	}
];

export function GetTopNavItems(topNavTabSettings, scope) {
	let items;
	switch (scope) {
		case DomainScopes.ELOKET:
			items = getTopNavItemsForEloket(topNavTabSettings);
			break;
		case DomainScopes.ZOEKMOTOR:
		default:
			items = getTopNavItemsForZoekmotor(topNavTabSettings);
			break;
	}

	return items;
}

function getTopNavItemsForEloket(topNavTabSettings) {
	return Object.keys(topNavTabSettings).map(key => {
		const tabSettings = topNavTabSettings[key];
		let result;
		key === "naarOverzichtTab" ?
			result = {
				text: tabSettings.text,
				to: "/e-loket/" + tabSettings.urlSuffix, //sportkamp/inlichtingsfiche/:sportkampId
				iconType: tabSettings.iconType,
				color: tabSettings.color,
				disabled: tabSettings.disabled,
				visible: tabSettings.visible
			}
			:
			result = {
				text: tabSettings.text,
				to: "/e-loket/" + tabSettings.urlSuffix, //sportkamp/inlichtingsfiche/:sportkampId
				iconType: tabSettings.iconType,
				color: tabSettings.color,
				disabled: tabSettings.disabled,
				visible: tabSettings.visible
			};

		return result;
	});
}

function getTopNavItemsForZoekmotor(topNavTabSettings) {
	return Object.keys(topNavTabSettings).map(key => {
		const tabSettings = topNavTabSettings[key];
		return {
			text: tabSettings.text,
			to: "/zoekmotor/" + tabSettings.urlSuffix, //sportkamp/inlichtingsfiche/:sportkampId
			iconType: tabSettings.iconType,
			color: tabSettings.color,
			disabled: tabSettings.disabled,
			visible: tabSettings.visible
		};
	});
}

export function formatValidatieStatussesForBeads(validatieStatusses) {
	return validatieStatusses.map(v => {
		const tabType = tabTypes.find(x => x.typeId == v.entiteitType);
		return {
			tab: tabType ? tabType.tabNumber : null,
			volledig: v.volledig,
			title: v.titel || (tabType ? tabType.title : null),
			entiteitGuid: v.entiteitGuid
		};
	});
}

export function formatValidatieStatussesForSideNav(validatieStatusses) {
	const sideNavValidatieStatusses = validatieStatusses.filter(v => v.entiteitType == tabTypes[2].typeId).sort(v => v.titel);
	return sideNavValidatieStatusses.map(v => {
		return {
			url: "/lussen/" + v.tochtGuid + "/" + v.entiteitGuid,
			display: v.titel,
			linkEnabled: true,
			lusId: v.entiteitGuid
		};
	});
}

export function getFirstValidatieStatusForLusSideNav(validatieStatusses) {
	return orderByPropertyName(validatieStatusses.filter(v => v.entiteitType == tabTypes[2].typeId), 'titel')[0];
}
